import { render, staticRenderFns } from "./bonusIssue.vue?vue&type=template&id=3a9f0e40&lang=pug"
import script from "./bonusIssue.vue?vue&type=script&lang=js"
export * from "./bonusIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports